module.exports = __webpack_public_path__ + "img/new-password.105173b8.svg";